import script from "./FoodManageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FoodManageView.vue?vue&type=script&setup=true&lang=ts"

import "./FoodManageView.vue?vue&type=style&index=0&id=3f0488cd&scoped=true&lang=less"
import "./FoodManageView.vue?vue&type=style&index=1&id=3f0488cd&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_typescript@5.8.3__webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0488cd"]])

export default __exports__